import { appConnect } from '~/store/hooks'
import { compose } from 'redux'
import { graphql } from '@apollo/client/react/hoc'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

import { getStepNumber } from 'config/onboarding'
import { getTitle } from 'config/titles'

import { GET_USER_QUERY } from 'client/queries'
import { UPDATE_USER_MUTATION } from 'client/mutations'
import Onboarding from 'components/Onboarding'
import { useNetwork } from '~/networkProvider'
import { FacilityScreenContainer } from '~/components/FacilityScreenContainer'

const OnboardingComfortZonesScreen = ({ ...props }) => {
  const { online } = useNetwork()
  return (
    <FacilityScreenContainer>
      <Helmet>
        <title>{getTitle('comfortZones')}</title>
      </Helmet>
      <Onboarding
        {...props}
        online={online}
        step={getStepNumber('Zones')}
        message="Draw and configure your comfort zones."
      />
    </FacilityScreenContainer>
  )
}

OnboardingComfortZonesScreen.propTypes = {
  onModalClose: PropTypes.func,
  userId: PropTypes.string,
  data: PropTypes.object,
}

const mapStateToProps = ({ auth }) => ({
  userId: auth.userId,
})

export default compose(
  graphql(GET_USER_QUERY, {
    options: ({ userId }) => ({ variables: { id: userId } }),
  }),
  graphql(UPDATE_USER_MUTATION, {
    props: ({ mutate }) => ({
      onModalClose: variables => mutate({ variables }),
    }),
  }),
  appConnect(mapStateToProps)
)(OnboardingComfortZonesScreen)
